// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const ERRORS_TYPE = {
  permission: 'NotAllowedError: Permission denied',
};

export const ERRORS_MESSAGES = {
  [ERRORS_TYPE.permission]: 'Error no camera permissions',
};
